import { render, staticRenderFns } from "./pullVcWelfareCoupon.vue?vue&type=template&id=2467f176&scoped=true"
import script from "./pullVcWelfareCoupon.vue?vue&type=script&lang=js"
export * from "./pullVcWelfareCoupon.vue?vue&type=script&lang=js"
import style0 from "./pullVcWelfareCoupon.vue?vue&type=style&index=0&id=2467f176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467f176",
  null
  
)

export default component.exports